import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { API } from "@/lib/api";
import { useWishlist } from "@/context/WishlistContext";

const resolveImg = (img) =>
  !img ? "https://images.pexels.com/photos/4202325/pexels-photo-4202325.jpeg?w=400" :
  img.startsWith("http") ? img : `${API}/files/${img}`;

export default function ProductCard({ product, priority = false }) {
  const img = resolveImg(product.images?.[0]);
  const { has, toggle } = useWishlist();
  const liked = has(product.id);

  const onLike = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(product.id);
  };

  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block bg-card border border-border hover:-translate-y-1 hover:shadow-lg transition-all duration-300 rounded-sm overflow-hidden"
      style={{ transitionProperty: "transform, box-shadow" }}
    >
      <div className="aspect-[4/5] overflow-hidden bg-secondary relative">
        <img
          src={img}
          alt={product.title}
          loading={priority ? "eager" : "lazy"}
          className="w-full h-full object-cover group-hover:scale-[1.04]"
          style={{ transition: "transform 0.6s ease" }}
        />
        {product.is_founding_seller && (
          <span className="absolute top-3 left-3 founding-badge text-[10px] tracking-[0.15em] uppercase font-semibold px-2.5 py-1 rounded-sm">
            ◦ Founding Seller
          </span>
        )}
        <button
          onClick={onLike}
          data-testid={`wishlist-toggle-${product.id}`}
          aria-label={liked ? "Remove from wishlist" : "Add to wishlist"}
          className="absolute top-3 right-3 w-9 h-9 bg-background/90 backdrop-blur-sm border border-border rounded-full flex items-center justify-center hover:bg-background transition-colors"
        >
          <Heart className={`w-4 h-4 transition-colors ${liked ? "fill-primary text-primary" : "text-foreground"}`} />
        </button>
      </div>
      <div className="p-5">
        <div className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground font-medium">{product.category}</div>
        <h3 className="font-serif text-xl mt-2 leading-tight tracking-tight">{product.title}</h3>
        <div className="flex items-baseline justify-between mt-3">
          <span className="text-sm font-semibold">{product.has_variants ? "from " : ""}${Number(product.price).toFixed(2)}</span>
          <span className="text-xs text-muted-foreground italic">{product.seller_name}</span>
        </div>
      </div>
    </Link>
  );
}
